export * from './date-fns'
export * from './groups'
export * from './private-route'
export * from './normalize-path'

export const isCustomer = userId => {
  return [1293,1768,1769].indexOf(userId) !== -1
}
